module.exports = __webpack_public_path__ + "f25bb4938aadcd50dbced3143f385868.svg";